import React from 'react'
import { Usabilla as ZionUsabilla } from '@fs/zion-usabilla'
import { useExperiment } from '@fs/zion-experiments'
import { useQueryParams } from '@fs/zion-router'

export default function SharedUsabilla() {
  const [recordsGetFeedbackEx] = useExperiment('recordsGetFeedbackEx')
  const { query } = useQueryParams({ replaceState: true })
  let usabillaUrl

  if (query.view === 'index') usabillaUrl = '//w.usabilla.com/bb7f49bb22c9.js'
  else if (query.view === 'fullText') usabillaUrl = '//w.usabilla.com/44df9f18d43c.js'
  else usabillaUrl = `//w.usabilla.com/45c3add7853e.js`

  if (recordsGetFeedbackEx) {
    return <ZionUsabilla url={usabillaUrl} hideOnMobile mobileBreakpoint="md" />
  }
  return null
}
